/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} List_SettingsInputs */

const en_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List Settings`)
};

const fr_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de la liste`)
};

const de_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listeneinstellungen`)
};

const it_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni elenco`)
};

const ru_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки списка`)
};

const es_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de lista`)
};

const zh_cn2_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`列表设置`)
};

const ja_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リスト設定`)
};

const hi_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची सेटिंग्स`)
};

const pt_pt2_list_settings = /** @type {(inputs: List_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações da lista`)
};

/**
* | output |
* | --- |
* | "List Settings" |
*
* @param {List_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const list_settings = /** @type {((inputs?: List_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<List_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_list_settings(inputs)
	if (locale === "de") return de_list_settings(inputs)
	if (locale === "it") return it_list_settings(inputs)
	if (locale === "ru") return ru_list_settings(inputs)
	if (locale === "es") return es_list_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_list_settings(inputs)
	if (locale === "ja") return ja_list_settings(inputs)
	if (locale === "hi") return hi_list_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_list_settings(inputs)
	return en_list_settings(inputs)
});